import React, { useState } from 'react';
import ValidationFields, { ValidationValues } from '../components/ValidationFields';

const Validation: React.FC = () => {
  const [values, setValues] = useState<ValidationValues>({
    orgId: '',
    createDate: '',
    trust: 'medium',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Demo behavior: show the submitted values
    alert(
      `Submitted:\n` +
      `Org ID: ${values.orgId}\n` +
      `Create Date: ${values.createDate}\n` +
      `Trust: ${values.trust}`
    );
  };

  const handleReset = () =>
    setValues({ orgId: '', createDate: '', trust: 'medium' });

  return (
    <div className="container mt-4">
      <h1 className="mb-3">Validation</h1>
      <form onSubmit={handleSubmit}>
        <ValidationFields values={values} onChange={setValues} />
        <div className="d-flex gap-2">
          <button type="submit" className="btn btn-primary">Submit</button>
          <button type="button" className="btn btn-outline-secondary" onClick={handleReset}>
            Reset
          </button>
        </div>
      </form>
    </div>
  );
};

export default Validation;
